import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'endDateInput',
    'startDateInput',
    'submitButton'
  ];

  declare endDateInputTarget: HTMLInputElement;
  declare startDateInputTarget: HTMLInputElement;
  declare submitButtonTarget: HTMLInputElement;

  connect(): void {
    EB.Datepicker.initDatePickers(new Date());

    this.element.addEventListener('turbo:submit-start', () => {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.value = 'Saving...';
      this.submitButtonTarget.classList.add('btn--disabled');
    });

    this.element.addEventListener("turbo:submit-end", (event) => {
      if (event.detail.success) {
        const closeLink = this.element.querySelector<HTMLElement>('[rel="modal:close"]');
        closeLink?.click();
        const closeTurboModal = document.querySelector<HTMLElement>('.turbo-modal-component__close-modal');
        closeTurboModal?.click();
        this.reload_location(event);
      } else {
        this.submitButtonTarget.disabled = false;
        this.submitButtonTarget.value = 'Save Vote Box';
        this.submitButtonTarget.classList.remove('btn--disabled');
      }
    });
  }

  public textIntoStartDateField(event) {
    event.preventDefault();
    this.startDateInputTarget.value = event.target.textContent
    this.startDateInputTarget.focus()
  }

  public textIntoEndDateField(event) {
    event.preventDefault();
    this.endDateInputTarget.value = event.target.textContent
    this.endDateInputTarget.focus()
  }

  private reload_location(_event) {
    location.reload();
  }
}
